<template>
  <apexchart
    v-if="loaded"
    type="bar"
    width="100%"
    height="600"
    :options="chartOptions"
    :series="series"
  ></apexchart>

  <v-skeleton-loader v-else class="mx-auto" type="image"></v-skeleton-loader>
</template>

<script>
import axios from "@/plugins/axios";
// import moment from "moment";
export default {
  data() {
    return {
      error: null,
      chartOptions: null,
      series: [],
      loaded: false,
    };
  },
  methods: {
    getChartData() {
      let that = this;
      axios
        .get("/api/v1/ticket/updates-per-agent")
        .then((response) => {
          // Stacked chart data
          that.series = response.data.counts;
          let labels = response.data.agents;
          that.chartOptions = {
            colors: ["#f5da42", "#f53131", "#1db0e0", "#4a4a4a", "#969696"],
            chart: {
              type: "bar",
              height: 600,
              stacked: true,
            },
            plotOptions: {
              bar: {
                horizontal: true,
                dataLabels: {
                  total: {
                    enabled: true,
                    offsetX: 0,
                    style: {
                      fontSize: "13px",
                      fontWeight: 900,
                    },
                  },
                },
              },
            },
            xaxis: {
              categories: labels,
              labels: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            tooltip: {
              theme: "dark",
              y: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            fill: {
              opacity: 1,
            },
          };
        })
        .then(() => {
          that.loaded = true;
        });
    },
  },
  created() {
    this.getChartData();
  },
};
</script>

<style lang="scss" scoped></style>
